<template>
  <div class="is-position-relative">
    <div class="is-position-relative float-right"
         :class="{ 'opacity-ligne-select' : masqueRemise
                     && !hover && isEditPrevisu }">
      <small> {{ remise }}</small>
    </div>
    <div v-if="(masqueRemise || hover) && isEditPrevisu"
         class="height-21px has-text-centered eyes-icon-aligement">
      <b-icon :icon="((masqueRemise && !hover)
      || (hover && !masqueRemise)) ? 'eye-off' : 'eye'"
              custom-size="mdi-16px"
              type="is-link"
              :class="[{ 'white-round-22': hover },
                          { 'opacity-ligne-select': masqueRemise && !hover }]"
      ></b-icon>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    remise: {
      type: String,
      required: true,
    },
    masqueRemise: {
      type: Boolean,
      required: true,
    },
    hover: {
      type: Boolean,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: true,
    },
  },
};

</script>
